import React from 'react';
import { api } from '@shootsta/client-auth';
import RequestProvider from '../../RequestProvider';
import SocialAuthButtonListComponent from '../components/SocialAuthButtonList';


const { loginSocialApi } = api || {};

const SocialAuthButtonList = (props) =>
<RequestProvider
  requests={{
    loginSocial: loginSocialApi()
  }}>

    {(requests) =>
  <SocialAuthButtonListComponent
    {...props}
    {...requests} />}


  </RequestProvider>;


export default SocialAuthButtonList;